//      
import {               } from 'css-box-model';
import { invariant } from '../../invariant';
import { add, subtract } from '../position';
import {
  canScrollWindow,
  canScrollDroppable,
  getWindowOverlap,
  getDroppableOverlap,
} from './can-scroll';
import whatIsDraggedOver from '../droppable/what-is-dragged-over';
import {               } from '../action-creators';
             
                     
           
                
              
                     

              
                                                               
                                           
                                  
   

                                                          

                          

export default ({
  move,
  scrollDroppable,
  scrollWindow,
}      )               => {
  const moveByOffset = (state               , offset          ) => {
    const client           = add(state.current.client.selection, offset);
    move({ client });
  };

  const scrollDroppableAsMuchAsItCan = (
    droppable                    ,
    change          ,
  )             => {
    // Droppable cannot absorb any of the scroll
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    const overlap            = getDroppableOverlap(droppable, change);

    // Droppable can absorb the entire change
    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    // Droppable can only absorb a part of the change
    const whatTheDroppableCanScroll           = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);

    const remainder           = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  const scrollWindowAsMuchAsItCan = (
    isWindowScrollAllowed         ,
    viewport          ,
    change          ,
  )            => {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      // window cannot absorb any of the scroll
      return change;
    }

    const overlap            = getWindowOverlap(viewport, change);

    // window can absorb entire scroll
    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    // window can only absorb a part of the scroll
    const whatTheWindowCanScroll           = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);

    const remainder           = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  const jumpScroller               = (state               ) => {
    const request            = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    const destination               = whatIsDraggedOver(state.impact);
    invariant(
      destination,
      'Cannot perform a jump scroll when there is no destination',
    );

    // 1. We scroll the droppable first if we can to avoid the draggable
    // leaving the list

    const droppableRemainder            = scrollDroppableAsMuchAsItCan(
      state.dimensions.droppables[destination],
      request,
    );

    // droppable absorbed the entire scroll
    if (!droppableRemainder) {
      return;
    }

    const viewport           = state.viewport;
    const windowRemainder            = scrollWindowAsMuchAsItCan(
      state.isWindowScrollAllowed,
      viewport,
      droppableRemainder,
    );

    // window could absorb all the droppable remainder
    if (!windowRemainder) {
      return;
    }

    // The entire scroll could not be absorbed by the droppable and window
    // so we manually move whatever is left
    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/auto-scroller/jump-scroller.js